import type { JSX } from 'react';
import { useState, useEffect, useRef } from 'react';
import './SkillBar.css';

interface SkillBarProps {
  name: string;
  percentage: number;
  colorVar: string;
}

export default function SkillBar({ name, percentage, colorVar }: SkillBarProps): JSX.Element {
  const [animated, setAnimated] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (el === null) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting === true) {
          setAnimated(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.4 },
    );
    observer.observe(el);
    return () => { observer.disconnect(); };
  }, []);

  return (
    <div className="SkillBar" ref={ref}>
      <div className="SkillBar__info">
        <span className="SkillBar__name">{name}</span>
        <span className="SkillBar__pct">{percentage}%</span>
      </div>
      <div className="SkillBar__track">
        <div
          className="SkillBar__fill"
          style={{
            width: animated ? `${String(percentage)}%` : '0%',
            background: colorVar,
          }}
        />
      </div>
    </div>
  );
}
